import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

export class ParentName extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): ParentName {
    if (!(value.length > 0)) {
      throw new Error('名前が入力されていません');
    }
    return new ParentName(value);
  }

  /** ラベル */
  static get label(): string {
    return '名前';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return '太郎';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }

  /** 文字列にする */
  override toString() {
    return this.value;
  }
}
